import { render, staticRenderFns } from "./StoreServiceScoreDetail.vue?vue&type=template&id=21e2c286&scoped=true&"
import script from "./StoreServiceScoreDetail.vue?vue&type=script&lang=js&"
export * from "./StoreServiceScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./StoreServiceScoreDetail.vue?vue&type=style&index=0&id=21e2c286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e2c286",
  null
  
)

export default component.exports